import Styled from 'styled-components'

export const Container = Styled.div`
margin: 0;
padding: 0;
`
export const ContainerProduct = Styled.div`

justify-content: space-between;

display: flex;

@media(max-width: 800px) {
 flex-direction: column;
 margin-top: 10px;
} 

`

export const Banner = Styled.div`
    position: relative;
    width: 100%;

    .carousel-wl {
        padding-bottom: 24px;
    }

    .carousel-inner {
        height: 303px;
        background-color: #d9d9d9;
    }

    .carousel-item,
    .carousel-item img {
        height: 303px;
    }

    .carousel-item img {
        width: 100%;
        object-fit: cover;
        object-position: center;
        background-color: #d9d9d9;
    }

    .carousel-indicators {
        margin-bottom: 0 !important;
        bottom: 0;
    }

    .carousel-indicators [data-bs-target] {
        width: 5px;
        height: 5px;
        background-color: #d9d9d9;
        opacity: 1;
    }

    .carousel-indicators .active {
        width: 8px;
        height: 8px;
        background-color: #1d1d1f;
    }

    .carousel-control-prev-icon,
    .carousel-control-next-icon {
        background-image: none !important;
    }

    @media (min-width: 1024px) {
        .carousel-wl {
            padding-bottom: 0;
        }

        .carousel-inner {
            height: auto;
            background-color: transparent;
        }

        .carousel-item,
        .carousel-item img {
            height: auto;
        }

        .carousel-item img {
            max-height: 520px;
            border-radius: 12px;
        }

        .carousel-indicators {
            margin-bottom: -20px !important;
        }
    }
`

export const Content = Styled.div`
width: 100%;
margin-top: 24px;
padding: 0 32px;
h3 {
  font-size: 30px;
  font-weight: 400;
  word-wrap: break-word
}

@media (min-width: 1024px) {
  margin-top: 0;
  padding: 0;
}
`;

export const Cashback = Styled.p`
color: white;
background-color: black;
font-size: 0.8rem;
text-align: center;
padding: 6px;

@media(max-width: 800px) {
    margin-top: 40px;
    font-size: 0.6rem; 
}

`

export const Title = Styled.h3`
  max-width: 350px;
  margin-bottom: 0;
  overflow: hidden;
  color: #1D1D1F;
  font-family: var(--font-family);
  font-size: 16px !important;
  font-style: normal;
  font-weight: 600 !important;
  line-height: 24px !important;
  max-height: ${({ $maxHeight }) => $maxHeight || "none"};
  transition: max-height 280ms ease-in-out;

  ${({ $isExpandable }) =>
    $isExpandable &&
    `
      cursor: pointer;
    `}
`

export const Spots = Styled.p`
margin: 25px 0;
font-weight: bolder;
font-size: 28px;

span{
    font-size: 18px;
    color: black;
}

`
export const Details = Styled.p`
font-weight: 500;
style: medium;
font-size: 16px;
color: ${props => props.theme.whitelabel?.theme?.text_primary_color};
line-height: 150%;
letter-spacing: 0%;
`

export const CuttingStitches = Styled.del`
color: #757575;

`

export const Description = Styled.p`
font-weight: 400;
color: ${props => props.theme.whitelabel?.theme?.text_primary_color};
font-size: 14px;
line-height: 150%;
font-style: regular;
letter-spacing: 0%;
`

export const SoldBy = Styled.p`
font-style: normal;
color: #1D1D1F;
font-size: 14px;
font-weight: 600;
line-height: 142.857%;
margin-bottom: 16px;
margin-top: 0;
`

export const Brand = Styled.p`
font-style: normal;
color: #1D1D1F;
font-size: 14px;
font-weight: 600;
line-height: 20px;
margin-top: 16px;
margin-bottom: 24px;
`

export const Space = Styled.div`
height: 50px;
`
export const CashbackInfo = Styled.div`
    background: ${props => props.theme.primary};
    height: 22px;
    
    display: flex;
    align-items: center;
    justify-content: center;
    
    p {
        color: #FAFBFF;
        text-align: center;
        font-weight: 600;
        font-size: 12px;
        line-height: 15px;
    }
`

export const StarIcon = Styled.div`
    position: absolute;
    right: 16px;
    top: 16px;
    z-index: 10;
    padding: 8px;
    cursor: pointer;
    display: flex;
    align-items: center;
    justify-content: center;
`

export const VariationGrid = Styled.div`
  display: grid;
  grid-template-columns: 1fr 1fr;
  gap: 16px;
  margin-top: 24px;
  margin-bottom: 24px;
`

export const VariationLabel = Styled.label`
  font-size: 14px;
  font-weight: 500;
  color: #414141;
  line-height: 1.5;
  margin-bottom: 8px;
  display: block;
`

export const VariationSelect = Styled.select`
  width: 100%;
  border: none;
  border-bottom: 1px solid #1D1D1F;
  background: transparent;
  font-size: 16px;
  font-weight: 400;
  color: #1D1D1F;
  line-height: 1.5;
  padding: 4px 0;
  outline: none;
  appearance: none;
  -webkit-appearance: none;
  background-image: url("data:image/svg+xml,%3Csvg xmlns='http://www.w3.org/2000/svg' width='12' height='12' viewBox='0 0 12 12'%3E%3Cpath d='M2 4L6 8L10 4' stroke='%231D1D1F' stroke-width='1.5' fill='none'/%3E%3C/svg%3E");
  background-repeat: no-repeat;
  background-position: right 4px center;
  padding-right: 24px;
  cursor: pointer;
  font-family: var(--font-family);
`

export const AccordionWrapper = Styled.div`
  margin-top: 32px;
  padding-bottom: 80px;

  @media (min-width: 1024px) {
    padding-bottom: 0;
  }

  .accordion {
    border: none;
  }

  .accordion-item {
    border: none;
    background: transparent;
  }

  .accordion-header {
    border: none;
  }

  .accordion-button {
    background: transparent;
    border: none;
    box-shadow: none;
    padding: 0;
    font-size: 14px;
    font-style: normal;
    font-weight: 600;
    line-height: 20px;
    color: #000000;
    margin-bottom: 24px;
    font-family: var(--font-family);

    &:not(.collapsed) {
      background: transparent;
      color: #000000;
      box-shadow: none;
    }

    &::after {
      background-size: 16px;
    }
  }

  .accordion-body {
    padding: 0 0 24px 0;
  }
`

export const ShippingPlaceholder = Styled.div`
  margin-top: 32px;
`

export const ProductDivider = Styled.hr`
  border: none;
  border-top: 0.75px solid #595959;
  margin: 24px 0 24px 0;
`

export const FixedFooter = Styled.div`
  position: fixed;
  bottom: 0;
  left: 0;
  right: 0;
  z-index: 10;
  background: white;
  border-top: 1px solid #d9d9d9;
  padding: 16px 32px;
  display: flex;
  justify-content: center;
  align-items: center;

  @media (min-width: 1024px) {
    display: none;
  }
`;

/* ===== Desktop (>=1024px): PDP em 2 colunas ===== */
export const ProductLayout = Styled.div`
  /* mobile: mantém o padding lateral que antes vinha do Content */
  .pdp-details { padding: 0 32px; }

  @media (min-width: 1024px) {
    display: grid;
    grid-template-columns: minmax(0, 1fr) minmax(0, 1fr);
    gap: 48px;
    max-width: 1320px;
    margin: 0 auto;
    padding: 32px 32px 0;
    align-items: start;

    .pdp-gallery { grid-column: 1; }
    .pdp-info    { grid-column: 2; }
    .pdp-buy     { margin-top: 24px; }
    .pdp-details { grid-column: 1 / -1; padding: 0; }
    .pdp-details hr { margin-top: 0; }
  }
`;
